import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout } from "../layouts";
import {
  Users,
  Blog,
  Courses,
  Menu,
  Newsletter,
  AcademicCycle,
  Subject,
  Syllabu,
  Media,
  MediaEdit,
  MediaShow,
  Grade,
  Level,
  Permission,
  Role,
  PaymentCategory,
  Student,
  Document,
  InstitutionalDocument,
  AcademicManagement,
  Forum,
  Post,
  LiveClass,
  ClassSchedule,
  Attendance,
  AttendanceGeneral,
  AttendanceByClass,
  Dashboard,
  Events,
  Admin,
  Academic,
  Notifications,
  Competence,
  GradeRegistration,
  Payments,
  CashRegisterPage,
  FinancialReportsPage,
} from "../pages/admin";

export function AdminRouter() {
  const loadLayout = (Layout, Page) => {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  };

  return (
    <Routes>
      <Route
        path="/login/*"
        element={<Navigate to="/admin/dashboard" replace />}
      />
      <Route
        path="/student/*"
        element={<Navigate to="/admin/dashboard" replace />}
      />
      {["/admin", "/admin/dashboard"].map((path) => (
        <Route
          key={path}
          path={path}
          element={loadLayout(AdminLayout, Dashboard)}
        />
      ))}
      <Route path="/admin/blog" element={loadLayout(AdminLayout, Blog)} />
      <Route path="/admin/users" element={loadLayout(AdminLayout, Users)} />
      <Route path="/admin/courses" element={loadLayout(AdminLayout, Courses)} />
      <Route path="/admin/menu" element={loadLayout(AdminLayout, Menu)} />
      <Route path="/admin/role" element={loadLayout(AdminLayout, Role)} />
      <Route
        path="/admin/permission"
        element={loadLayout(AdminLayout, Permission)}
      />
      <Route
        path="/admin/academicCycle"
        element={loadLayout(AdminLayout, AcademicCycle)}
      />
      <Route
        path="/admin/academicCycle/:academicCycleId/students"
        element={loadLayout(AdminLayout, Student)}
      />
      <Route
        path="/admin/academicCycle/:academicCycleId/academicManagement"
        element={loadLayout(AdminLayout, AcademicManagement)}
      />
      <Route
        path="/admin/academicCycle/:academicCycleId/classSchedules"
        element={loadLayout(AdminLayout, ClassSchedule)}
      />
      <Route
        path="/admin/attendance"
        element={loadLayout(AdminLayout, Attendance)}
      />
      <Route
        path="/admin/attendance/:academicCycleId/general"
        element={loadLayout(AdminLayout, AttendanceGeneral)}
      />
      <Route
        path="/admin/attendance/:academicCycleId/class"
        element={loadLayout(AdminLayout, AttendanceByClass)}
      />
      <Route path="/admin/forum" element={loadLayout(AdminLayout, Forum)} />
      <Route
        path="/admin/post/:postId"
        element={loadLayout(AdminLayout, Post)}
      />
      <Route path="/admin/subject" element={loadLayout(AdminLayout, Subject)} />
      <Route path="/admin/syllabu" element={loadLayout(AdminLayout, Syllabu)} />
      <Route
        path="/admin/media/:syllabuId"
        element={loadLayout(AdminLayout, Media)}
      />
      <Route
        path="/admin/media/:syllabuSubjectGradeId/edit"
        element={loadLayout(AdminLayout, MediaEdit)}
      />
      <Route
        path="/admin/media/:syllabuSubjectGradeId/show"
        element={loadLayout(AdminLayout, MediaShow)}
      />
      <Route path="/admin/grade" element={loadLayout(AdminLayout, Grade)} />
      <Route path="/admin/level" element={loadLayout(AdminLayout, Level)} />
      <Route
        path="/admin/document"
        element={loadLayout(AdminLayout, Document)}
      />
      <Route
        path="/admin/institutional-documents"
        element={loadLayout(AdminLayout, InstitutionalDocument)}
      />
      <Route
        path="/admin/paymentCategory"
        element={loadLayout(AdminLayout, PaymentCategory)}
      />
      <Route path="/admin/Student" element={loadLayout(AdminLayout, Student)} />
      <Route
        path="/admin/newsletter"
        element={loadLayout(AdminLayout, Newsletter)}
      />
      <Route
        path="/admin/liveClasses"
        element={loadLayout(AdminLayout, LiveClass)}
      />
      <Route path="/admin/events" element={loadLayout(AdminLayout, Events)} />
      <Route
        path="/admin/report/admin"
        element={loadLayout(AdminLayout, Admin)}
      />
      <Route
        path="/admin/report/academic"
        element={loadLayout(AdminLayout, Academic)}
      />
      <Route
        path="/admin/notifications"
        element={loadLayout(AdminLayout, Notifications)}
      />
      <Route
        path="/admin/competence"
        element={loadLayout(AdminLayout, Competence)}
      />
      <Route
        path="/admin/academicCycle/:academicCycleId/grades"
        element={loadLayout(AdminLayout, GradeRegistration)}
      />
      <Route
        path="/admin/payments/validate"
        element={loadLayout(AdminLayout, Payments)}
      />
      <Route
        path="/admin/cash-register"
        element={loadLayout(AdminLayout, CashRegisterPage)}
      />
      <Route
        path="/admin/reports/financial"
        element={loadLayout(AdminLayout, FinancialReportsPage)}
      />
    </Routes>
  );
}
